
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/nouveautes",
      function () {
        return require("private-next-pages/nouveautes.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/nouveautes"])
      });
    }
  